import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { DepartmentService } from '../../../services/department.service';
import { Department } from '../../../models/department';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-department-dialog',
  templateUrl: './department-dialog.component.html',
  styleUrls: ['./department-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class DepartmentDialogComponent implements OnInit {

  //public Editor = ClassicEditor;
  public isEdit: boolean; // is insert or update
  
  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form

  public spinner: boolean = false;

  public Editor = ClassicEditor;

  constructor(
    private fb: FormBuilder,
    private _departmentService: DepartmentService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: Department
  ) { }


  ngOnInit() {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
    } else {
      this.isEdit = false
    }
    
    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)    
  }

  insert() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Department = this.createEntity(this.entityForm.value);

      this._departmentService.insert(entity)
        .then((result) => {
          this.data.id = entity.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(entity.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert regional error: " + error)
          this.snackBar.openSnackBar("Erro", '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Department = this.createEntity(this.entityForm.value);

      this._departmentService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("department update error: " + JSON.stringify(error))
          this.snackBar.openSnackBar('Erro', '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  createEntity(data: any): Department {
    let entity = new Department();
    entity.id = data.id;
    entity.context_id = data.context_id;
    entity.name = data.name;
    entity.short = data.short;
    entity.text = data.text || '';
    return entity;
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.context_id.setValue(data.context_id);
    form.controls.name.setValue(data.name);
    form.controls.short.setValue(data.short);
    form.controls.text.setValue(data.text);
  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      context_id: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
      short: new FormControl('', [Validators.required]),
      text: new FormControl('')
    });
    return form
  }


}

